import io from 'socket.io-client'

export default ({ $config }, inject) => {
  inject('socket', io.connect($config.VUE_APP_API_IP))
}
